module.exports = __webpack_public_path__ + "img/tratamiento_outline_red.a0f3f373.svg";